import React from 'react'
import { shallow } from 'enzyme'
import PodCardBody from '../PodCardBody'
import AdminList from '../AdminList'

describe('<PodCardBody />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      admins: []
    }
    wrapper = shallow(<PodCardBody {...props} />)
  })
  it('should render three <AdminList />s', () => {
    expect(wrapper.find(AdminList)).toHaveLength(3)
  })
})
